const EVENT_NAME = {
  LOGIN_PAGE_VIEW: 'LoginPage_View',
  LOGIN_PAGE_CLICK: 'LoginPage_Click',
  OPEN_IDENTITY_PAGE_VIEW: 'OpenIdentityPage_View',
  OPEN_IDENTITY_PAGE_CLICK: 'OpenIdentityPage_Click',
  COUPON_GITE_OUT: 'Coupon_GiveOut',
  COUPON_VERTIFICATION: 'Coupon_Vertification',
  CRM_TAB_CLICK: 'CRM_Tab_Click',
  CRM_TABPAGE_VIEW: 'CRM_TabPage_View',
  DEPOSIT_PAGE_VIEW: 'DepositPage_View',
  DEPOSIT_PAGE_CLICK: 'DepositPage_Click',
  DEPOSIT_DETAIL_PAGE_VIEW: 'DepositDetailPage_View',
  DEPOSIT_DETAIL_PAGE_CLICK: 'DepositDetailPage_Click',
  WITHDRAW_PAGE_VIEW: 'WithdrawPage_View',
  SHARE_METHOD_CLICK: 'ShareMethod_Click',
  DEPOSIT_PAGE_STEP1_VIEW: 'DepositPage_Step1_View',
  DEPOSIT_PAGE_STEP1_CLICK: 'Deposit_Step1_Click',

  // deposit
  DEPOSIT_STEP1PAGE_VIEW: 'Deposit_Step1Page_View',
  DEPOSITPAGE_BACK_CLICK: 'DepositPage_Back_Click',
  DEPOSIT_STEP1PAGE_ACCOUNT_SELECT: 'Deposit_Step1Page_Account_Select',
  DEPOSIT_STEP1PAGE_AMOUNT_INPUT: 'Deposit_Step1Page_Amount_Input',
  DEPOSIT_STEP1PAGE_VOUCHER_USE: 'Deposit_Step1Page_Voucher_Use',
  DEPOSIT_STEP1PAGE_CONTINUE_CLICK: 'Deposit_Step1Page_Continue_Click',
  DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY: 'Deposit_Step2Page_JumpThirdParty',
  DEPOSIT_STEP2_CCCHECKOUTPAGE_VIEW: 'Deposit_Step2_CCCheckoutPage_View',
  DEPOSIT_STEP3_CCBRIDGERPAGE_VIEW: 'Deposit_Step3_CCBridgerPage_View',
  DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK: 'Deposit_Step2_IBTPageTermsPopup_Confirm_Click',
  DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW: 'Deposit_PoPUP_AdvancedKYCReq_View',
  DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK: 'Deposit_PoPUP_AdvancedKYCReq_Click',
  DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW: 'Deposit_PopUp_MinDepositUnmet_View',
  DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK: 'Deposit_PopUp_MinDepositUnmet_Click',
  DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW: 'Deposit_PopUp_MaxDepositUnmet_View',
  DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK: 'Deposit_PopUp_MaxDepositUnmet_Click',
  DEPOSIT_POPUP_COUPONUNUSABLE_VIEW: 'Deposit_PopUp_CouponUnusable_View',
  DEPOSIT_POPUP_COUPONUNUSABLE_CLICK: 'Deposit_PopUp_CouponUnusable_Click',
  DEPOSIT_RESULTPAGE_VIEW: 'Deposit_ResultPage_View',
  DEPOSIT_RETRY_CLICK: 'Deposit_Retry_Click',
  DEPOSIT_BACKTOHOMEPAGE_CLICK: 'Deposit_BackToHomePage_Click',

  // withdrawal
  WITHDRAWAL_STEP1PAGE_VIEW: 'Withdrawal_Step1Page_View',
  WITHDRAWALPAGE_BACK_CLICK: 'WithdrawalPage_Back_Click',
  WITHDRAWAL_STEP1PAGE_ACCOUNT_CLICK: 'Withdrawal_Step1Page_Account_Click',
  WITHDRAWAL_STEP1PAGE_AMOUNT_INPUT: 'Withdrawal_Step1Page_Amount_Input',
  WITHDRAWAL_STEP1PAGE_CONTINUE_CLICK: 'Withdrawal_Step1Page_Continue_Click',
  WITHDRAWAL_STEP2_VIEW: 'Withdrawal_Step2_View',
  WITHDRAWAL_STEP2_DETAILPAGE_VIEW: 'Withdrawal_Step2_DetailPage_View',
  WITHDRAWAL_STEP2_DETAILPAGE_SUBMIT_CLICK: 'Withdrawal_Step2_DetailPage_Submit_Click',
  WITHDRAWALPOPUP_STEP2_YETTOHAVE2FA_CLICK: 'WithdrawalPopUp_Step2_YetToHave2FA_Click',
  WITHDRAWALPOPUP_STEP2_ALREADYHAVE2FA_CLICK: 'WithdrawalPopUp_Step2_AlreadyHave2FA_Click',
  WITHDRAWAL_STEP2_ARCHIVECARD_SETTING: 'Withdrawal_Step2_ArchiveCard_Setting',
  WITHDRAWAL_STEP2_SELECTBANKACCOUNT_SETTING: 'Withdrawal_Step2_SelectBankAccount_Setting',
  WITHDRAWALPOPUP_WITHDRAWALONHOLD_VIEW: 'WithdrawalPopUp_WithdrawalOnHold_View',
  WITHDRAWALPOPUP_WITHDRAWALONHOLD_CLICK: 'WithdrawalPopUp_WithdrawalOnHold_Click',
  WITHDRAWAL_RESULTPAGE_VIEW: 'Withdrawal_ResultPage_View',
  WITHDRAWAL_BACKTOHOMEPAGE_CLICK: 'Withdrawal_BackToHomePage_Click',

  // promotion
  PROMO_PAGE_CLICK: 'PromoPage_Click',
  PROMO_PAGE_VIEW: 'PromoPage_View',
  PROMO_PAGE_LEAVE: 'PromoPage_Leave',
}

const BUTTON_NAME = {
  LOGIN: 'Login',
  EMAIL_LOGIN: 'Email Login',
  MOBILE_LOGIN: 'Mobile Login',
  TELEGRAM_LOGIN: 'Telegram Login',
  LV1_NEXT: 'Lv1-Next',
  LV1_DEPOSIT: 'Lv1-Deposit Preparation',
  LV1_BACK: 'Lv1-Back',
  LV2_NEXT: 'Lv2-Next',
  LV2_DEPOSIT: 'Lv2-Deposit Preparation',
  LV2_DOWNLOAD: 'Lv2-Download',
  LV2_BACK: 'Lv2-Back',
  LV3_NEXT: 'Lv3-Next',
  LV3_DEPOSIT: 'Lv3-Deposit Preparation',
  LV3_DOWNLOAD: 'Lv3-Download',
  LV3_BACK: 'Lv3-Back',
  LV3_WITHDRAW: 'Lv3-Withdraw',
  ASIC_NEXT: 'ASIC-Next',
  FCA_NEXT: 'FCA-Next',
  DEPOSIT_PAY_NOW: 'Pay Now',
  OPT_IN: 'Opt In',
  OPT_OUT: 'Opt Out',
  TRADE_NOW: 'Trade Now',
  DEPOSIT_NOW: 'Deposit Now',
  BONUS_HISTORY: 'Bonus History',
  FAQ: 'faq',
}

// 开户审核阶段
const IDENTITY_LEVEL = {
  LV1: 'Lv1.Account Opening',
  LV2: 'Lv2.ID Authentication',
  LV3: 'Lv3.POA Authentication',
  ASIC: 'ASIC',
  FCA: 'FCA',
}

// 开户审核步骤
const IDENTITY_STEP = {
  LV1_PERSONAL_INFORMATION: 'Lv1-Personal Information',
  LV1_ACCOUNT_CONFIGURATION: 'Lv1-Account Configuration',
  LV1_ACCOUNT_PASSED: 'Lv1-Live account passed',
  LV2_ID_INFORMATION: 'Lv2-ID Information',
  LV2_ID_PASSED: 'Lv2-ID Passed',
  LV3_POA_INFORMATION: 'Lv3-POA Information',
  LV3_POA_PASSED: 'Lv3-POA Passed',
  ASIC: 'ASIC',
  FCA: 'FCA',
}

// 渠道名称
const DEPOSIT_METHOD = {
  BRIDGE_PAYMENT: 'Bridge Payment',
  CREDIT_CARD: 'Credit Card',
  APPLE_GOOGLE_PAY: 'Apple Pay/Google Pay',
  SOLID_PAYMENT: 'Solid Payment',
}

const SHARE_TYPE = {
  FACEBOOK: 'Facebook',
  TWITTER: 'Twitter',
  WHATSAPP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  COPY_LINK: 'Copy Link',
  EMAIL: 'Email',
}

const ACTIVITY_NAME = {
  REFER_A_FRIEND: 'Refer A Friend',
  DEPOSIT_BONUS: 'Deposit Bonus',
  NO_DEPOSIT_BONUS: 'No Deposit Bonus',
  TRADING_CONTEST: 'Trading Contest',
  TRADING_REWARDS: 'Trading Rewards',
  LUCKY_DRAW: 'Lucky Draw',
  VPS_REFUND: 'VPS Refund',
  FUNDS_GROW_PROMO: 'Funds Growth Promotion',
  WELCOME_BONUS: 'Welcome Bonus',
  RE_DEPOSIT_BONUS: 'Redeposit Bonus',
}

/**
 * 神策上报事件常量集合
 */
export const SENSORS_TRACK = {
  EVENT_NAME,
  BUTTON_NAME,
  IDENTITY_LEVEL,
  IDENTITY_STEP,
  DEPOSIT_METHOD,
  SHARE_TYPE,
  ACTIVITY_NAME,
}

/**
 * path 映射 tabName
 * 只有在这个表中的 path 才会上报到神策
 */
export const URL_TO_TAB_NAME = {
  '/home': 'Home',
  '/liveAccount': 'Accounts',
  '/funds': 'Funds',
  '/depositFunds': 'Funds_Deposit',
  '/withdrawFunds': 'Funds_Withdraw',
  '/transferFunds': 'Funds_Transfer',
  '/paymentDetails': 'Funds_Payment Details',
  '/transactionHistory': 'Funds_Transaction',
  '/downloads': 'Downloads',
  '/myProfile': 'PersonalInfo',
  '/securityManagement': 'SecurityManagement',
  '/tradingTool/MARKET_BUZZ': 'TradingTool_MARKET_BUZZ',
  '/tradingTool/ECON_CALENDAR': 'TradingTool_ECON_CALENDAR',
  '/tradingTool/FEAT_FX': 'TradingTool_Featured ideas',
  '/tradingTool/FX_IDEAS': 'TradingTool_Analyst views',
  '/tradingTool/AS_CENTRE': 'TradingTool_Acuity Signal Centre',
  '/vtrade/Provider': 'VTrade_Provider',
  '/vtrade/becomes-a-follower': 'VTrade_Follower',
  '/vtrade/Login': 'VTrade_Login',
  '/referFriends': 'Promotions_Refer A Friend',
  '/referFriendsThai': 'Promotions_Refer A Friend Thailand',
  '/depositBonus/7': 'Promotions_Deposit Bonus',
  '/depositBonus/5': 'Promotions_Deposit Bonus',
  '/redepositBonus': 'Promotions_Redeposit Bonus',
  '/welcomeBonus': 'Promotions_Welcome Bonus',
  '/noDepositBonus': 'Promotions_No Deposit Bonus',
  '/dailyNewsletter': 'Promotions_Daily Newsletter',
  '/lossRecover': 'Promotions_Loss Recover',
  '/fundsGrowthPromotion': 'Promotions_13% p.a. Funds Growth',
  '/vpsRefund': 'Promotions_VPS Refund',
  '/clubBleu': 'ClubBleu',
  '/support': 'Support',
}
